import { StyleShadowRoot } from "@redotech/react-util/style";
import { DeliveryEstimate as DeliveryEstimateType } from "@redotech/redo-conversion-core-common/conversion/conversion-autocheck";
import { WidgetAutocheck } from "@redotech/redo-storefront-widget-common/widget";
import { ModalRootContext } from "@redotech/redo-web/modal-root";
import { memo } from "react";
import { LocationClientProvider } from "../../location/location-client-context";
import STYLE_MANAGER from "../../style-manager";
import { DeliveryEstimate } from "./delivery-estimate";
import { useCartRenderPortals } from "./use-cart-render-portals";
import { useRenderPdps } from "./use-render-pdps";
import { ZipCodeProvider } from "./zip-code-context";

export const DeliveryEstimateInitializer = memo(
  function DeliveryEstimateInitializer({
    deliveryEstimateSettings,
    autocheck,
  }: {
    deliveryEstimateSettings: DeliveryEstimateType;
    autocheck: WidgetAutocheck;
  }) {
    const pdpPortals = useRenderPdps({
      deliveryEstimate: deliveryEstimateSettings,
    });
    const cartPortals = useCartRenderPortals({
      deliveryEstimate: deliveryEstimateSettings,
    });

    const allPortals = [...pdpPortals, ...cartPortals];

    if (allPortals.length === 0) {
      return null;
    }

    return (
      <LocationClientProvider>
        <ZipCodeProvider>
          {allPortals.map(({ foundSelector, portal }, index) => (
            <StyleShadowRoot
              key={index}
              shadowRoot={portal.root}
              styleManager={STYLE_MANAGER}
            >
              <ModalRootContext.Provider value={portal.modalContainer}>
                <DeliveryEstimate
                  customCopy={deliveryEstimateSettings.customCopy}
                  estimatedDeliveryDate={
                    deliveryEstimateSettings.estimatedDeliveryDate
                  }
                  estimatedDeliveryDateRange={
                    deliveryEstimateSettings.estimatedDeliveryDateRange
                  }
                />
              </ModalRootContext.Provider>
            </StyleShadowRoot>
          ))}
        </ZipCodeProvider>
      </LocationClientProvider>
    );
  },
);
